import { EntityIdAliasPrefixes } from '@abb-procure/constants';
import {
  Component,
  DestroyRef,
  OnInit,
  inject,
  ChangeDetectionStrategy,
} from '@angular/core';
import {
  MAT_DIALOG_DATA,
  MatDialogContent,
  MatDialogRef,
} from '@angular/material/dialog';
import { FileHashPipe } from '../../pipes/file-hash.pipe';
import { escapeDialog } from '../../utilities/dialog.util';
import { Button } from '../button/button.component';

export type StatusWorkflowDialogData = {
  entityType: EntityIdAliasPrefixes;
};

@Component({
  templateUrl: './status-workflow-dialog.component.html',
  styleUrl: './status-workflow-dialog.component.scss',
  imports: [MatDialogContent, Button, FileHashPipe],
  changeDetection: ChangeDetectionStrategy.Eager,
})
export class StatusWorkflowDialog implements OnInit {
  protected readonly data: StatusWorkflowDialogData = inject(MAT_DIALOG_DATA);
  protected readonly EntityIdAliasPrefixes = EntityIdAliasPrefixes;
  protected readonly image = `/assets/images/workflows/${this.data.entityType.toLowerCase()}.png`;

  private readonly dialogRef = inject(MatDialogRef);
  private readonly destroyRef = inject(DestroyRef);

  ngOnInit(): void {
    escapeDialog(this.dialogRef, this.destroyRef, () => this.onClose());
  }

  onClose(): void {
    this.dialogRef.close();
  }
}
